import { Show } from 'solid-js'
import Button from '~/components/Button'
import Card from '~/components/Card'
import Icon from '~/components/Icon'
import Input from '~/components/Input'
import Switch from '~/components/Switch'
import { generateSlug } from '~/utils/slug'
import type { TabGeneralProps } from './types'

/** Pestaña General: datos básicos de la empresa y notificaciones. */
function TabGeneral(props: TabGeneralProps) {
  const { form } = props

  return (
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <Card>
        <Card.Title>
          <div class="flex items-center">
            <Icon icon="material-symbols-light:domain" size={20} class="mr-2" />
            <h2 class="text-xl font-semibold">Datos de la empresa</h2>
          </div>
        </Card.Title>
        <Card.Body>
          <div class="space-y-4">
            <Input name="name" label="Nombre" />
            <Input name="domain" label="Dominio" placeholder="ejemplo.com" />
            <Input
              name="slug"
              label="Slug"
              placeholder="mi-empresa"
              endIcon={
                <Button
                  size="sm"
                  variant="text"
                  icon="material-symbols-light:autorenew"
                  onClick={() => form.setValue('slug', generateSlug((form.values().name as string) || ''))}
                  title="Generar slug desde el nombre"
                />
              }
            />
          </div>
        </Card.Body>
      </Card>

      <Card>
        <Card.Title>
          <div class="flex items-center">
            <Icon icon="material-symbols-light:notifications-outline" size={20} class="mr-2" />
            <h2 class="text-xl font-semibold">Notificaciones</h2>
          </div>
        </Card.Title>
        <Card.Body>
          <div class="space-y-4">
            <Switch name="notifyByEmail" label="Notificaciones por email" checked={Boolean(form.values().notifyByEmail)} />
            <Switch name="notifyInApp" label="Notificaciones en la aplicación" checked={Boolean(form.values().notifyInApp)} />
            <Show when={form.values().notifyByEmail}>
              <Input name="notificationEmail" label="Correo para notificaciones" type="email" placeholder="correo@ejemplo.com" />
            </Show>
          </div>
        </Card.Body>
      </Card>
    </div>
  )
}

export default TabGeneral
